var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component.is,_vm._g(_vm._b({tag:"component"},'component',_vm.component.bind,false),_vm.component.on),[_vm._v(" "+_vm._s(_vm.component.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }